import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    value: Yup.string()
        .required('Value is required')
        .max(20, 'Max 20 characters'),
});